var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "play",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_236",
    "data-name": "\\u6955\\u5186\\u5F62 236",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(5 5)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play_circle_FILL1_wght400_GRAD0_opsz48",
    d: "M28.24,49.6,49.6,36,28.24,22.4ZM36,68a30.963,30.963,0,0,1-12.4-2.52A32.24,32.24,0,0,1,6.52,48.4,30.963,30.963,0,0,1,4,36,31.16,31.16,0,0,1,6.52,23.52,31.98,31.98,0,0,1,13.4,13.36,32.8,32.8,0,0,1,23.6,6.52,30.963,30.963,0,0,1,36,4,31.16,31.16,0,0,1,48.48,6.52a31.95,31.95,0,0,1,17,17A31.16,31.16,0,0,1,68,36a30.963,30.963,0,0,1-2.52,12.4,32.8,32.8,0,0,1-6.84,10.2,31.98,31.98,0,0,1-10.16,6.88A31.16,31.16,0,0,1,36,68Z",
    transform: "translate(-4 -4)",
    fill: "#5fc7bc"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.80d5060612d52ff4c885b50a99257678.svg";
export { ForwardRef as ReactComponent };